var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingSiren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.696,
    height: 14,
    viewBox: "0 0 13.696 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "siren",
    transform: "translate(-5.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_958",
    "data-name": "\\uADF8\\uB8F9 958",
    transform: "translate(11.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_957",
    "data-name": "\\uADF8\\uB8F9 957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3217",
    "data-name": "\\uD328\\uC2A4 3217",
    d: "M239.761,0a.457.457,0,0,0-.457.457V1.37a.457.457,0,1,0,.913,0V.457A.457.457,0,0,0,239.761,0Z",
    transform: "translate(-239.304)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_960",
    "data-name": "\\uADF8\\uB8F9 960",
    transform: "translate(5.565 6.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_959",
    "data-name": "\\uADF8\\uB8F9 959",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3218",
    "data-name": "\\uD328\\uC2A4 3218",
    d: "M6.935,233.739H6.022a.457.457,0,0,0,0,.913h.913a.457.457,0,0,0,0-.913Z",
    transform: "translate(-5.565 -233.739)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_962",
    "data-name": "\\uADF8\\uB8F9 962",
    transform: "translate(17.435 6.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_961",
    "data-name": "\\uADF8\\uB8F9 961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3219",
    "data-name": "\\uD328\\uC2A4 3219",
    d: "M441.022,233.739h-.913a.457.457,0,0,0,0,.913h.913a.457.457,0,0,0,0-.913Z",
    transform: "translate(-439.652 -233.739)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_964",
    "data-name": "\\uADF8\\uB8F9 964",
    transform: "translate(15.83 1.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_963",
    "data-name": "\\uADF8\\uB8F9 963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3220",
    "data-name": "\\uD328\\uC2A4 3220",
    d: "M382.392,68.6a.457.457,0,0,0-.646,0l-.646.646a.457.457,0,0,0,.645.646l.646-.646A.457.457,0,0,0,382.392,68.6Z",
    transform: "translate(-380.967 -68.463)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_966",
    "data-name": "\\uADF8\\uB8F9 966",
    transform: "translate(7.437 1.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_965",
    "data-name": "\\uADF8\\uB8F9 965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3221",
    "data-name": "\\uD328\\uC2A4 3221",
    d: "M75.447,69.242,74.8,68.6a.457.457,0,0,0-.646.646l.646.646a.457.457,0,0,0,.646-.646Z",
    transform: "translate(-74.022 -68.463)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_968",
    "data-name": "\\uADF8\\uB8F9 968",
    transform: "translate(7.391 11.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_967",
    "data-name": "\\uADF8\\uB8F9 967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3222",
    "data-name": "\\uD328\\uC2A4 3222",
    d: "M81.935,434.087H72.8a.457.457,0,0,0-.457.457v1.217a.457.457,0,0,0,.457.457h9.13a.457.457,0,0,0,.457-.457v-1.217A.457.457,0,0,0,81.935,434.087Z",
    transform: "translate(-72.348 -434.087)",
    fill: "#42495b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_970",
    "data-name": "\\uADF8\\uB8F9 970",
    transform: "translate(8.304 2.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_969",
    "data-name": "\\uADF8\\uB8F9 969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3223",
    "data-name": "\\uD328\\uC2A4 3223",
    d: "M109.848,100.174a4.113,4.113,0,0,0-4.109,4.109v4.109h8.217v-4.109A4.113,4.113,0,0,0,109.848,100.174Zm1.826,4.565a.457.457,0,0,1-.457-.457,1.371,1.371,0,0,0-1.37-1.37.457.457,0,1,1,0-.913,2.285,2.285,0,0,1,2.283,2.283A.457.457,0,0,1,111.674,104.739Z",
    transform: "translate(-105.739 -100.174)",
    fill: "#42495b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSiren);
export default __webpack_public_path__ + "static/media/parking_siren.7361b6759cf5db3aaab877ee0fb5d9b3.svg";
export { ForwardRef as ReactComponent };